import React from 'react';
import { Lock, Target } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { AllGoalTypes } from '@momentum/types';

interface InteractionGoalProps {
  goalId?: string;
  goals: AllGoalTypes[];
}

export const InteractionGoal: React.FC<InteractionGoalProps> = ({
  goalId,
  goals,
}) => {
  const { t } = useTranslation('interactions');
  const { t: tGoals } = useTranslation('goals');

  // No goal linked to the interaction
  if (!goalId) {
    return (
      <span className="text-sm text-muted-foreground font-medium">
        {t('noGoal')}
      </span>
    );
  }

  const goal = goals.find((g) => g._id === goalId);
  const isRestricted = !goal;

  return (
    <div className="flex items-center gap-2">
      {isRestricted ? (
        <Lock className="h-4 w-4 text-gray-500 flex-shrink-0" />
      ) : (
        <Target className="h-4 w-4 text-primary flex-shrink-0" />
      )}
      <span className="text-sm text-muted-foreground font-medium">
        {isRestricted ? tGoals('restrictedGoal.title') : goal?.title}
      </span>
    </div>
  );
};
